import { Component, OnInit } from '@angular/core';
import { FinancialManagerService } from '../../../../services/financial-manager';
import { HomeService } from '../../../../services/home.service';
import { UserService } from '../../../../services/user';
import { UserInterface } from '../../../../interfaces/user-interface';
import { ItemsService } from '../../../../services/items.service';
import Swal from 'sweetalert2';
import { forkJoin } from 'rxjs';

interface DayCalendarItem {
  date: Date;
  dayNumber: string;
  isCurrentMonth: boolean;
  isToday: boolean;
  isSelected: boolean;
  isDisabled: boolean;
}

@Component({
  selector: 'app-dailyexpensesmobile',
  templateUrl: './dailyexpensesmobile.component.html',
  styleUrl: './dailyexpensesmobile.component.scss'
})
export class DailyexpensesmobileComponent implements OnInit {
  selectedYear!: number;
  selectedMonth!: string;
  month!: string;

  years: number[] = [];
  months = [
    { value: '01', name_ar: 'يناير', name_en: 'January' },
    { value: '02', name_ar: 'فبراير', name_en: 'February' },
    { value: '03', name_ar: 'مارس', name_en: 'March' },
    { value: '04', name_ar: 'أبريل', name_en: 'April' },
    { value: '05', name_ar: 'مايو', name_en: 'May' },
    { value: '06', name_ar: 'يونيو', name_en: 'June' },
    { value: '07', name_ar: 'يوليو', name_en: 'July' },
    { value: '08', name_ar: 'أغسطس', name_en: 'August' },
    { value: '09', name_ar: 'سبتمبر', name_en: 'September' },
    { value: '10', name_ar: 'أكتوبر', name_en: 'October' },
    { value: '11', name_ar: 'نوفمبر', name_en: 'November' },
    { value: '12', name_ar: 'ديسمبر', name_en: 'December' }
  ];

  id!: any;
  contentReady = true;

  expenses: any[] = [];
  Revenues: any[] = [];

  expenseTotal = 0;
  revenueTotal = 0;
  revenueTotalCash = 0;
  expenseTotalCash = 0;
  revenueTotalOnlinePayment = 0;
  expenseTotalOnlinePayment = 0;

  isAr: boolean = localStorage.getItem('language') === 'ar';

  showFinPopUp = false;
  amount: any = null;
  note = '';
  finId: any = null;
  amount_type: any = '0';

  accountType!: string;
  isAdmin = false;
  isSubAdmin = false;

  day: any = null;
  allUsers: UserInterface[] = [];
  warehouseId!: any;
  allWareHouses: any[] = [];
  warehouseIsStore = false;
  canShowDeliveryHeroCollecting = true;

  showExpenses = true;
  showRevenues = true;
  activeTab: 'expenses' | 'revenues' = 'expenses';

  showFilters = false;
  showAdminActions = false;

  showDayCalendar: boolean = false;
  dayCalendarViewDate: Date = new Date();

  constructor(
    private _FinancialManager: FinancialManagerService,
    private _userService: UserService,
    private _ItemsService: ItemsService,
    private _homeService: HomeService
  ) {
    const today = new Date();

    this.selectedYear = today.getFullYear();
    this.selectedMonth = (today.getMonth() + 1).toString().padStart(2, '0');
    this.dayCalendarViewDate = new Date(today.getFullYear(), today.getMonth(), 1);

    this.updateMonth();

    for (let y = 2015; y <= 2030; y++) {
      this.years.push(y);
    }
  }

  ngOnInit(): void {
    this.warehouseId = localStorage.getItem('posId');

    this.loadWarehouseType();
    this.loadAccountType();
    this.loadCurrentUserId();
    this.getAllUsers();
    this.getWarehouses();
    this.getByMonth();
  }

  get netTotal(): number {
    return this.revenueTotal - this.expenseTotal;
  }

  private loadWarehouseType(): void {
    this._userService.getWarehouseType(Number(this.warehouseId)).subscribe({
      next: (data) => {
        const warehouseType = String(data?.['warehouses_type']);
        this.warehouseIsStore = warehouseType === '0';
        this.canShowDeliveryHeroCollecting = warehouseType !== '4';
      },
      error: (error) => console.error(error)
    });
  }

  private loadAccountType(): void {
    this._userService.getAccountType().subscribe({
      next: (data) => {
        this.accountType = data?.['user_type'];
        this.isAdmin = this.accountType === '1' || this.accountType === '10';
        this.isSubAdmin = this.accountType === '6';
      },
      error: (error) => console.error(error)
    });
  }

  private loadCurrentUserId(): void {
    this._userService.getUserId().subscribe({
      next: (data) => {
        this.id = data?.['user_id'];
      },
      error: (error) => console.error(error)
    });
  }

  private getWarehouses(): void {
    this._ItemsService.getWearHouses().subscribe({
      next: (res) => {
        this.allWareHouses = res?.warehouse || [];
      },
      error: (err) => console.error(err)
    });
  }

  toggleExpenses(): void {
    this.showExpenses = !this.showExpenses;

    if (!this.showExpenses && this.activeTab === 'expenses') {
      this.activeTab = 'revenues';
    }

    if (!this.showExpenses && !this.showRevenues) {
      this.showRevenues = true;
      this.activeTab = 'revenues';
    }
  }

  toggleRevenues(): void {
    this.showRevenues = !this.showRevenues;

    if (!this.showRevenues && this.activeTab === 'revenues') {
      this.activeTab = 'expenses';
    }

    if (!this.showExpenses && !this.showRevenues) {
      this.showExpenses = true;
      this.activeTab = 'expenses';
    }
  }

  applyWareHouse(warehouseId: any): void {
    this.warehouseId = warehouseId;
    this.loadWarehouseType();
    this.day ? this.getByDate() : this.getByMonth();
  }

  onMonthYearChange(): void {
    this.updateMonth();
    this.getByMonth();
  }

  getByMonth(): void {
    this.day = null;
    this.closeDayCalendar();
    this.updateMonth();
    this.contentReady = true;

    forkJoin({
      revenues: this._FinancialManager.getInbalanceByMonth(this.month, this.warehouseId),
      expenses: this._FinancialManager.getOutbalanceByMonth(this.month, this.warehouseId)
    }).subscribe({
      next: ({ revenues, expenses }) => {
        this.Revenues = revenues || [];
        this.expenses = expenses || [];
        this.calculateTotal();
      },
      error: (err) => {
        console.error(err);
        this.contentReady = false;
      }
    });
  }

  getByDate(): void {
    if (!this.day) {
      this.getByMonth();
      return;
    }

    this.contentReady = true;

    forkJoin({
      revenues: this._FinancialManager.getInbalanceByDate(this.day, this.warehouseId),
      expenses: this._FinancialManager.getOutbalanceByDate(this.day, this.warehouseId)
    }).subscribe({
      next: ({ revenues, expenses }) => {
        this.Revenues = revenues || [];
        this.expenses = expenses || [];
        this.calculateTotal();
      },
      error: (err) => {
        console.error(err);
        this.contentReady = false;
      }
    });
  }

  clearDayFilter(): void {
    this.day = null;
    this.closeDayCalendar();
    this.getByMonth();
  }

  updateMonth(): void {
    this.month = `${this.selectedYear}-${this.selectedMonth}`;
  }

  calculateTotal(): void {
    let revenueTotal = 0;
    let expenseTotal = 0;
    let revenueTotalCash = 0;
    let expenseTotalCash = 0;
    let revenueTotalOnlinePayment = 0;
    let expenseTotalOnlinePayment = 0;

    this.Revenues.forEach((item) => {
      const amount = Number(item?.amount || 0);

      if (String(item?.amount_type) === '0') {
        revenueTotalCash += amount;
      } else {
        revenueTotalOnlinePayment += amount;
      }

      revenueTotal += amount;
    });

    this.expenses.forEach((item) => {
      const amount = Number(item?.amount || 0);

      if (String(item?.amount_type) === '0') {
        expenseTotalCash += amount;
      } else {
        expenseTotalOnlinePayment += amount;
      }

      expenseTotal += amount;
    });

    this.revenueTotal = revenueTotal;
    this.expenseTotal = expenseTotal;
    this.revenueTotalCash = revenueTotalCash;
    this.expenseTotalCash = expenseTotalCash;
    this.revenueTotalOnlinePayment = revenueTotalOnlinePayment;
    this.expenseTotalOnlinePayment = expenseTotalOnlinePayment;

    this.contentReady = false;
  }

  addExpenses(): void {
    this.finId = 1;
    this.amount_type = '0';
    this.showFinPopUp = true;
  }

  addRevenues(): void {
    this.finId = 2;
    this.amount_type = '0';
    this.showFinPopUp = true;
  }

  close(): void {
    this.finId = null;
    this.showFinPopUp = false;
    this.amount = null;
    this.note = '';
    this.amount_type = '0';
  }

  onSubmit(): void {
    if (!this.amount || Number(this.amount) <= 0) {
      Swal.fire({
        icon: 'warning',
        title: this.isAr ? 'تنبيه' : 'Warning',
        text: this.isAr ? 'من فضلك ادخل المبلغ' : 'Please enter amount'
      });
      return;
    }

    const username = localStorage.getItem('username');

    const payload = {
      warehouse_id: this.warehouseId || localStorage.getItem('posId'),
      employee_id: this.id,
      username,
      amount: this.amount,
      amount_type: this.amount_type,
      note: this.note
    };

    this.contentReady = true;

    if (this.finId === 1) {
      this._FinancialManager.addexpenses(payload).subscribe({
        next: () => {
          this.afterSubmitSuccess(this.isAr ? 'تم اضافة المصروف' : 'expenses added');
          this.activeTab = 'expenses';
        },
        error: (error) => {
          console.error(error);
          this.contentReady = false;
        }
      });
    } else {
      this._FinancialManager.addRevenue(payload).subscribe({
        next: () => {
          this.afterSubmitSuccess(this.isAr ? 'تم اضافة الربح' : 'revenue added');
          this.activeTab = 'revenues';
        },
        error: (error) => {
          console.error(error);
          this.contentReady = false;
        }
      });
    }
  }

  private afterSubmitSuccess(message: string): void {
    Swal.fire({
      icon: 'success',
      title: this.isAr ? 'تمام' : 'success',
      text: message
    });

    this.close();
    this.day ? this.getByDate() : this.getByMonth();
  }

  delete(type: any, id: any): void {
    const username = localStorage.getItem('username');

    Swal.fire({
      title: this.isAr ? 'متأكد؟؟' : 'Are You Sure?',
      showCancelButton: true,
      confirmButtonText: this.isAr ? 'اه' : 'YES',
      cancelButtonText: this.isAr ? 'لا' : 'no'
    }).then((result) => {
      if (!result.isConfirmed) {
        return;
      }

      this.contentReady = true;

      if (type === 1) {
        this._FinancialManager.deleteRev(id, username!).subscribe({
          next: () => {
            this.day ? this.getByDate() : this.getByMonth();
          },
          error: (err) => {
            console.error(err);
            this.contentReady = false;
          }
        });
      } else {
        this._FinancialManager.deleteEx(id, username!).subscribe({
          next: () => {
            this.day ? this.getByDate() : this.getByMonth();
          },
          error: (err) => {
            console.error(err);
            this.contentReady = false;
          }
        });
      }
    });
  }

  translateTypeEnum(type: any): string {
    switch (String(type)) {
      case '0':
        return this.isAr ? 'عمولة' : 'commission';
      case '1':
        return this.isAr ? 'راتب' : 'Salary';
      case '2':
        return this.isAr ? 'سلفة' : 'Loan';
      case '3':
        return this.isAr ? 'اوردر' : 'Order';
      case '4':
        return this.isAr ? 'توريد' : 'supply';
      default:
        return '';
    }
  }

  paymentTypeLabel(type: any): string {
    switch (String(type)) {
      case '0':
        return this.isAr ? 'كاش' : 'cash';
      case '1':
        return this.isAr ? 'فودافون كاش' : 'vodafone cash';
      case '2':
        return this.isAr ? 'انستا باي' : 'instapay';
      case '3':
        return this.isAr ? 'دفع أونلاين' : 'online payment';
      case '4':
        return this.isAr ? 'تحويل بنكي' : 'bank transfer';
      case '5':
        return this.isAr ? 'آجل' : 'credit';
      default:
        return '-';
    }
  }

  getAllUsers(): void {
    this._homeService.getAllUsers().subscribe({
      next: (data) => {
        this.allUsers = (data || []).filter((user: any) => user.type === 1 || user.type === 6);
      },
      error: (error) => console.error(error)
    });
  }

  userFilter(id: any): void {
    const month = `${this.selectedYear}-${this.selectedMonth}`;
    const day = this.day;

    this.contentReady = true;

    this._FinancialManager.getEmployeeBalances(id, month, day).subscribe({
      next: (res) => {
        this.expenses = res?.outbalances || [];
        this.Revenues = res?.inbalances || [];
        this.calculateTotal();
      },
      error: (err) => {
        console.error(err);
        this.contentReady = false;
      }
    });
  }

  getArchivedBalances(): void {
    this.contentReady = true;

    this._FinancialManager.getArchivedBalances(this.warehouseId).subscribe({
      next: (data) => {
        this.Revenues = data?.archived_imbalances || [];
        this.expenses = data?.archived_outbalances || [];
        this.calculateTotal();
      },
      error: (err) => {
        console.error('Error loading archived balances:', err);
        this.contentReady = false;
      }
    });
  }

  trackById(index: number, item: any): any {
    return item?.id || index;
  }

  /* ================================
     Day Calendar
     نفس Calendar بتاع New Booking
     ================================ */

  toggleDayCalendar(): void {
    this.showDayCalendar = !this.showDayCalendar;

    if (this.showDayCalendar) {
      const selectedDate = this.parseDateOnly(this.day);
      const baseDate = selectedDate || new Date();

      this.dayCalendarViewDate = new Date(
        baseDate.getFullYear(),
        baseDate.getMonth(),
        1
      );
    }
  }

  closeDayCalendar(): void {
    this.showDayCalendar = false;
  }

  previousDayCalendarMonth(): void {
    this.dayCalendarViewDate = new Date(
      this.dayCalendarViewDate.getFullYear(),
      this.dayCalendarViewDate.getMonth() - 1,
      1
    );
  }

  nextDayCalendarMonth(): void {
    this.dayCalendarViewDate = new Date(
      this.dayCalendarViewDate.getFullYear(),
      this.dayCalendarViewDate.getMonth() + 1,
      1
    );
  }

  getDayCalendarTitle(): string {
    return new Intl.DateTimeFormat(this.isAr ? 'ar-EG' : 'en-US', {
      month: 'long',
      year: 'numeric',
    }).format(this.dayCalendarViewDate);
  }

  getDayCalendarWeekDays(): string[] {
    return this.isAr
      ? ['الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت']
      : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  }

  getDayCalendarDays(): DayCalendarItem[] {
    const year = this.dayCalendarViewDate.getFullYear();
    const month = this.dayCalendarViewDate.getMonth();

    const firstDay = new Date(year, month, 1);
    const gridStart = new Date(year, month, 1 - firstDay.getDay());

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const selectedDate = this.parseDateOnly(this.day);

    return Array.from({ length: 42 }, (_, index) => {
      const date = new Date(gridStart);
      date.setDate(gridStart.getDate() + index);
      date.setHours(0, 0, 0, 0);

      return {
        date,
        dayNumber: this.isAr ? this.toArabicDigits(date.getDate()) : String(date.getDate()),
        isCurrentMonth: date.getMonth() === month,
        isToday: this.isSameDate(date, today),
        isSelected: selectedDate ? this.isSameDate(date, selectedDate) : false,

        // الفاينانس ممكن يحتاج تواريخ قديمة
        isDisabled: false
      };
    });
  }

  selectDayCalendarDate(date: Date): void {
    const selectedDate = new Date(date);
    selectedDate.setHours(0, 0, 0, 0);

    this.day = this.formatDateForInput(selectedDate);

    this.closeDayCalendar();
    this.getByDate();
  }

  getDayDisplay(): string {
    const selectedDate = this.parseDateOnly(this.day);

    if (!selectedDate) {
      return this.isAr ? 'اختار اليوم' : 'Select day';
    }

    return new Intl.DateTimeFormat(this.isAr ? 'ar-EG' : 'en-US', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    }).format(selectedDate);
  }

  private parseDateOnly(value: any): Date | null {
    if (!value) return null;

    const cleanValue = String(value)
      .replace('T', ' ')
      .replace('Z', '')
      .split('.')[0]
      .trim()
      .split(' ')[0];

    const match = cleanValue.match(/^(\d{4})-(\d{2})-(\d{2})$/);

    if (!match) return null;

    return new Date(
      Number(match[1]),
      Number(match[2]) - 1,
      Number(match[3])
    );
  }

  private isSameDate(first: Date, second: Date): boolean {
    return first.getFullYear() === second.getFullYear() &&
      first.getMonth() === second.getMonth() &&
      first.getDate() === second.getDate();
  }

  private formatDateForInput(date: Date): string {
    return [
      date.getFullYear(),
      String(date.getMonth() + 1).padStart(2, '0'),
      String(date.getDate()).padStart(2, '0'),
    ].join('-');
  }

  private toArabicDigits(value: string | number): string {
    return String(value).replace(/\d/g, (digit) => '٠١٢٣٤٥٦٧٨٩'[Number(digit)]);
  }
}